import axios from "axios";

function requestTablet3List(parameter) {
  return axios.post(
    `${process.env.VUE_APP_BASEURL}/api/app/tablet/tablet3-page`,
    parameter.tablet3
  );
}

function registTablet3(parameter) {
  return axios.post(
    `${process.env.VUE_APP_BASEURL}/api/app/tablet/regist/tablet3`,
    parameter.tablet3
  );
}
function requestTablet3Delete(id) {
  return axios.post(
    `${process.env.VUE_APP_BASEURL}/api/app/tablet/delete/tablet3?id=${id}`
  );
}
export { requestTablet3List, registTablet3, requestTablet3Delete };
